import React, { useContext } from 'react'

import { get } from 'lodash'

import { IDynamicFeatureContextValue } from './types'

const Context = React.createContext({
  initialized: false,
  configuration: {},
} as IDynamicFeatureContextValue)

export default Context

export const noProviderError = new Error('useDynamicFeatureContext must be used within a DynamicFeatureProvider')

export const useDynamicFeatureContext = (fieldName: string) => {
  const ctx = useContext(Context)
  if (!ctx.initialized) {
    throw noProviderError
  }
  return get(ctx, fieldName, true)
}
